import React, { useContext } from "react";
import { InlineNotification } from "carbon-components-react";

import { AmortizationContext } from "../AmortizationProvider";

const styles = require("./styles.module.scss");

const AmortizationInputs = () => {
  const { explainers } = useContext(AmortizationContext);

  if (!explainers.length) {
    return null;
  }

  return (
    <InlineNotification
      notificationType="inline"
      kind="warning"
      role="alert"
      hideCloseButton
      lowContrast
      title="Incomplete data"
      subtitle={
        <ul className={styles.list}>
          {explainers.map(e => (
            <li key={e}>{e}</li>
          ))}
        </ul>
      }
    />
  );
};

export default AmortizationInputs;
